import { useTranslation } from 'react-i18next';
import './successstories.scss';
import Spline from '@splinetool/react-spline';

const Successstories = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  const splineScene = isArabic
    ? "https://prod.spline.design/x7dzNXf754LbrhVh/scene.splinecode"
    : "https://prod.spline.design/bjz0PNfUkDJ1xnAU/scene.splinecode";

  return (
    <div className='success section container2'>
      <h1>{t('successStories.title')}</h1>
      <div className="spline__container">
        <Spline className="Spline_Screens" scene={splineScene} />
      </div>
    </div>
  )
}

export default Successstories;